/* this file is automatically generated.  edit at your own peril */
/* copyright 2015 Minted LLC.  All rights reserved */
var module; UMD(module, {
  'minted:m': ['M'],
  'minted:template': [],
  'minted:vendor/underscore-1.8.2.min': '_',
})(this, function (m_module, m_template, _) {
var M = m_module.M;

M.Template || (M.Template = {});
M.Template.DropdownPicker || (M.Template.DropdownPicker = {});

M.Template.DropdownPicker.DropdownPicker = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/* * Copyright (C) 2014 Minted Inc. * * All Rights Reserved */
__p+=' ';
 if
(pickerLabel) { 
__p+='\n<div class="floatL">\n  <h5>'+
((__t=( M.html.htmlAttributeEscape(pickerLabel) ))==null?'':__t)+
'</h5>\n</div>\n<div class="floatR dropdownPickerContainer">\n  ';
 } else { 
__p+='\n  <div class="floatL dropdownPickerContainer">\n    ';
 } 
__p+='\n\n    <div class="dropdownPickerTrigger">\n      <div class="pickerTriggerText pickerText">\n        '+
((__t=( M.html.htmlAttributeEscape(selectedOptionDisplayStr) ))==null?'':__t)+
'\n      </div>\n      <div class="pickerTriggerImage">\n        <img class="sprite arrowDownDefaultIcon"\n            src="'+
((__t=( M.img_src("/static/images/sprite_placeholder.png") ))==null?'':__t)+
'" />\n      </div>\n    </div>\n\n    <ul class="dropdownPickerDataSource pickerList">\n      ';
 for (var i in sortOptionsList) { 
__p+='\n      <li\n        class="dropdownPickerItem pickerText"\n        val="'+
((__t=( sortOptionsList[i]['option_val'] ))==null?'':__t)+
'"\n      >\n        '+
((__t=( M.html.htmlAttributeEscape(sortOptionsList[i]['display_str']) ))==null?'':__t)+
'\n      </li>\n      ';
 }; 
__p+='\n    </ul>\n  </div>\n</div>\n';
}
return __p;
});


return {};

});
/* end templito generated file */
